import React from 'react';
import displayName from 'component-lib/displayName';

import TextLabel from '../Widgets/Labels/TextLabel';
import CellBase from './CellBase';

export default class EmptyCell extends CellBase {
    static displayName = displayName('TableView/EmptyCell');

    static defaultProps = {
        ...CellBase.defaultProps,
        cellType: 'empty',
    };

    static contextTypes = CellBase.contextTypes;

    renderCell() {
        return (<TextLabel>
            {this.props.children}
        </TextLabel>);
    }
}
